import type { AppPlatform } from '@/api/gen-new/model';

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export type NativeAppInfo = {
	platform: AppPlatform;
	/** The store version: CFBundleShortVersionString on iOS, versionName on Android. */
	version: string;
};

let info: Promise<NativeAppInfo | null> | undefined;

/** The installed build, or null on the web, which always runs the latest bundle. */
export function getNativeAppInfo(): Promise<NativeAppInfo | null> {
	info ??= loadNativeAppInfo();
	return info;
}

async function loadNativeAppInfo(): Promise<NativeAppInfo | null> {
	const platform = Capacitor.getPlatform();
	if (platform !== 'ios' && platform !== 'android') {
		return null;
	}

	try {
		const { version } = await App.getInfo();
		return { platform, version };
	} catch {
		return null;
	}
}
